import { render, staticRenderFns } from "./AddMenu.vue?vue&type=template&id=70c32812&scoped=true"
import script from "./AddMenu.vue?vue&type=script&lang=js"
export * from "./AddMenu.vue?vue&type=script&lang=js"
import style0 from "./AddMenu.vue?vue&type=style&index=0&id=70c32812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c32812",
  null
  
)

export default component.exports